import React from 'react';
import logo from '../assets/LOGO-3GOVIDEO-128.png'; // Adjust the path as necessary
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="http://www.3GOVideo.com" target="_blank" rel="noopener noreferrer">
          <img src={logo} alt="logo 3GOVideo" className="mb-3" />
        </a>
        <p><strong>CONTÁCTENOS:</strong><br />
          <a href="tel:+573187073143">+57 318 707 3143</a> – <a href="tel:+573114741800">+57 311 474 1800</a><br />
          <a href="mailto:godb@3GOVideo.com">GoBD@3GOVideo.com</a> – <a href="mailto:gocto@3GOVideo.com">GoCto@3GOVideo.com</a><br />
          <a href="http://www.3govideo.com" target="_blank" rel="noopener noreferrer">www.3govideo.com</a>
        </p>
        <p>
          <a href="https://www.3govideo.com/" target='blank'>Sitio Web</a> |
          <a href="https://www.instagram.com/3govideo/" target='blank'>Instagram</a> |
          <a href="https://www.linkedin.com/company/3go-video" target='blank'>LinkedIn</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;